// extracted by mini-css-extract-plugin
export var button = "portfolio-module--button--1UvRV";
export var container = "portfolio-module--container--2FcgB";
export var container__boxes = "portfolio-module--container__boxes--OHp0x";
export var container__boxes__modal = "portfolio-module--container__boxes__modal--3NXZK";
export var container__boxes__modal__desc = "portfolio-module--container__boxes__modal__desc--1swA4";
export var container__boxes__modal__colors = "portfolio-module--container__boxes__modal__colors--39Yvj";
export var container__boxes__modal__typography = "portfolio-module--container__boxes__modal__typography--2IWCA";
export var container__boxes__box = "portfolio-module--container__boxes__box--aeBd2";